export const USER_TYPE = {
	APPLICANT: 'applicant',
	ORGANIZATION_MEMBER: 'organization_member'
}

export function isApplicantAccount(user = {}) {
	return user?.type === USER_TYPE.APPLICANT
}

export function isOrganizationMemberAccount(user = {}) {
	return user?.type === USER_TYPE.ORGANIZATION_MEMBER
}

export function hasApplicantProfile(user = {}) {
	return Boolean(user?.applicant_profile)
}

// Backend account invariant:
// applicant users may have applicant_profile and no current_organization.
// organization_member users may have current_organization and no applicant_profile.
// A payload with both is invalid, not a supported hybrid account state.
export function isOrganizationApplicationContext(user = {}) {
	return (
		isOrganizationMemberAccount(user) &&
		Boolean(user?.current_organization) &&
		!hasApplicantProfile(user)
	)
}

export function canAccessApplicantAssessment(user = {}) {
	return isApplicantAccount(user) && hasApplicantProfile(user)
}

export function isBlockedOrganizationAccount(user = {}) {
	return (
		isOrganizationMemberAccount(user) &&
		!user?.current_organization &&
		user?.can_create_organization === false
	)
}

export function isOrganizationAccountRoute(path = '') {
	return /^\/(user(?:\/|$)|auth(?:\/|$)|invitation\/[^/]+\/accept\/?$|organization-unavailable\/?$)/.test(
		path
	)
}

export function shouldBlockOrganizationRoute(user, path) {
	return (
		isBlockedOrganizationAccount(user) && !isOrganizationAccountRoute(path)
	)
}

export function hasRevokedOrganizationContext(user, previousOrganizationId) {
	return Boolean(
		isOrganizationMemberAccount(user) &&
			previousOrganizationId != null &&
			user?.current_organization &&
			String(user.current_organization.id) !==
				String(previousOrganizationId) &&
			Array.isArray(user.organizations) &&
			!user.organizations.some(
				organization =>
					String(organization.id) === String(previousOrganizationId)
			)
	)
}
